export default __webpack_public_path__ + "static/sprue-de4593230b0c765bde453c45c74c6663.webp";